import Controller from './Controller';

/*
const platno: HTMLCanvasElement = document.querySelector('#platno');
platno.width = window.innerWidth;
platno.height = window.innerHeight;
let kontext = platno.getContext('2d');
let vykreslit: any[] = [];
const pocet: HTMLInputElement = <HTMLInputElement>document.getElementById('pocet');

let ctverec = {
	x: 0,
	y: 0,
	strana: 40,
	barva: '#213536'
};

function smycka() {
	console.time('generovani');
	for (let i = 0; i < parseInt(pocet.value); i++) {
		posun();
		zmenBarvu();
		vykreslit.push({ ...ctverec });
	}
	console.timeEnd('generovani');
}

function posun() {
	const zlomekPosunu = 2;
	let smerX = Math.random() < 0.5 ? 1 : -1;
	let smerY = Math.random() < 0.5 ? 1 : -1;
	let konecX = Math.floor(window.innerWidth / ctverec.strana / zlomekPosunu) * ctverec.strana / zlomekPosunu;
	let konecY = Math.floor(window.innerHeight / ctverec.strana / zlomekPosunu) * ctverec.strana / zlomekPosunu;
	ctverec.x += ctverec.strana / zlomekPosunu * smerX;
	ctverec.y += ctverec.strana / zlomekPosunu * smerY;

	if (ctverec.y < 0) ctverec.y = 0;
	else if (ctverec.y > window.innerHeight) ctverec.y = konecY;
	if (ctverec.x < 0) ctverec.x = 0;
	else if (ctverec.x > window.innerWidth) ctverec.x = konecX;
}

function zmenBarvu() {
	let barvy = [ '#213536', '#48665A', '#628C5F', '#E1E2AB', '#A4BB83' ];
	if (Math.random() > 0.9) ctverec.barva = barvy[Math.floor(Math.random() * barvy.length)];
}

function prekresli() {
	console.time('kresleni');
	for (const ctverec of vykreslit) {
		kontext.fillStyle = ctverec.barva;
		kontext.fillRect(ctverec.x, ctverec.y, ctverec.strana, ctverec.strana);
	}
	vykreslit.splice(0, vykreslit.length);
	console.timeEnd('kresleni');
	requestAnimationFrame(prekresli);
}

setInterval(smycka, 16);
prekresli();
*/
new Controller();
